<template>
  <div>
    <div class="sign-content" v-show="isCreate">
      <div class="sign-content-h2">{{$t('page.supNotice.contentTitle')}}</div>
      <div class="sign-content-content">
        <p>{{$t('page.supNotice.contentP')[0]}}</p>
        <p>{{$t('page.supNotice.contentP')[1]}}</p>
        <p>{{$t('page.supNotice.contentP')[2]}}</p>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="regSourceShow"
        width="600px"
        show-divider
        show-shadow
        :close-on-click-modal="false"
        :before-close="handleClose"
        custom-class="el-dialog--customize"
      >
        <span>{{ dialogContent }}</span>
        <span slot="footer">
          <el-button size="mini" type="default-mini" @click="regSourceReturn"
            >取消</el-button
          >
          <el-button size="mini" type="primary-font-mini" @click="regSourceGo"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="registerPre()"
      >
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t('basicLayout.btn')[1] }}</span>
      </el-button>
    </div>
    <div v-show="isPhoneCompany">
      <RepeatPhone
        :companyList="companyList"
        @approval="approval"
        @isExist="isExist"
      ></RepeatPhone>
    </div>
    <div v-show="isNewCompany">
      <RegNewCompany @approval="approval" @isExist="isExist"></RegNewCompany>
    </div>
    <div v-show="isCompanyBeenReg">
      <CompanyBeenReg
        @approval="approval"
        @isExist="isExist"
        @next="nextViewFn"
      ></CompanyBeenReg>
    </div>
    <div v-show="isApprovaling">
      <Approvaling @approval="approval" @isExist="isExist"></Approvaling>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { Message } from "element-ui";
import countryCodes from "../../../../common/countryCode";
import RepeatPhone from "./repeatPhone";
import CompanyBeenReg from "./companyBeenReg";
import RegNewCompany from "./regNewCompany";
import Approvaling from "./approvaling";
import { getCheckContact, getPlatform, getPmcAdress } from "@/api/register";
export default {
  props: ["flag"],
  data() {
    const mobileRules = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const inputAuthCodeRules = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入六位数字验证码"));
      } else {
        callback();
      }
    };
    return {
      //缓存跳转数据
      jumpObj: {},
      //弹出框开始
      regSourceShow: false,
      agreeBtn: false,
      dialogContent: "",
      //弹出框结束
      //message高度
      messageHeight: null,
      mobile: "",
      name: "",
      show: true,
      second: "",
      timer: null,
      code: "",
      boll: false,
      country: countryCodes,
      isPhone: false,
      isNewCompany: false,
      isPhoneCompany: false,
      isCompanyBeenReg: false,
      isCreate: true,
      isApprovaling: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur",
          },
          // { max: 50, message: "数量在30个汉字以下", trigger: "blur" },
          {
            required: true,
            pattern: /^[^&]+$/,
            message: "不可输入&",
            trigger: ["blur"],
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: mobileRules, trigger: "blur" },
        ],
        inputAuthCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: inputAuthCodeRules, trigger: ["blur", "change"] },
        ],
      },
      form: {
        name: "",
        mobile: "",
        inputAuthCode: "",
      },
      select: "86",
      companyList: [],
      personInfo: {
        name: "",
        mobile: "",
      },
      isCode: false,
    };
  },
  components: {
    RepeatPhone,
    CompanyBeenReg,
    RegNewCompany,
    Approvaling,
  },
  watch: {
    flag: function (value) {
      if (value) {
        this.isPhone = false;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCompanyBeenReg = false;
        this.isCreate = true;
        this.$emit("toFlag");
      }
    },
  },
  created() {
  },
  mounted() {
    this.getBrowserHeight();
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    next() {
      this.changeCheckPage(2)
      this.$router.push({
        path: '/maPerfectInfo/moralAgreement',
        query: {
          tempSupinfoId:this.$route.query.tempSupinfoId,
          tempOrFormalFlag:this.$route.query.tempOrFormalFlag
        }
      })
    },
    registerPre() {
      this.changeCheckPage(0)
      this.$router.push({
        path:'/maReady01',
        query: {
          tempSupinfoId: this.$route.query.tempSupinfoId?this.$route.query.tempSupinfoId:this.tempSupinfoId,
          tempOrFormalFlag:this.$route.query.tempOrFormalFlag
        }
      })
    },
    //弹窗
    handleClose(done) {
      done();
    },
    //弹窗取消
    regSourceReturn() {
      this.regSourceShow = false;
      this.$router.push({
        path: "/",
      });
    },
    //弹窗确定
    regSourceGo() {
      this.regSourceShow = false;

      if (this.jumpObj.data.code === "0") {
        if (this.jumpObj.data.data.supplierState) {
          //物资
          console.log("111");
          if (this.jumpObj.data.data.supplierState === "0") {
            this.$router.push({
              path: "/maReady",
            });
            // sessionStorage.setItem(
            //   "localMa",
            //   JSON.stringify({
            //     check_page: "2",
            //     companyName: this.jumpObj.data.companyName,
            //     supplierCode: this.jumpObj.data.supplierCode
            //   })
            // );
            this.$eventBus.$emit("localMa", {
              check_page: "2",
              companyName: this.jumpObj.data.data.companyName,
              supplierCode: this.jumpObj.data.data.supplierCode,
            });
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21,
              });
            }
            return false;
          } else if (this.jumpObj.data.data.supplierState === "2") {
            this.$router.push({
              path: "/maReady",
            });
            // sessionStorage.setItem(
            //   "localMa",
            //   JSON.stringify({
            //     check_page: "4",
            //     companyName: this.jumpObj.data.companyName,
            //     success: true,
            //     supplierCode: this.jumpObj.data.supplierCode
            //   })
            // );
            this.$eventBus.$emit("localMa", {
              check_page: "4",
              success: true,
              companyName: this.jumpObj.data.data.companyName,
              supplierCode: this.jumpObj.data.data.supplierCode,
            });
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21,
              });
            }
            return false;
          } else if (this.jumpObj.data.data.supplierState === "4") {
            this.$router.push({
              path: "/maReady",
            });
            // sessionStorage.setItem(
            //   "localMa",
            //   JSON.stringify({
            //     check_page: "4",
            //     companyName: this.jumpObj.data.companyName,
            //     success: false,
            //     supplierCode: this.jumpObj.data.supplierCode
            //   })
            // );
            this.$eventBus.$emit("localMa", {
              check_page: "4",
              success: false,
              companyName: this.jumpObj.data.data.companyName,
              supplierCode: this.jumpObj.data.data.supplierCode,
            });
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21,
              });
            }
            return false;
          }

          //装备
          // if (this.jumpObj.data.data.regSource === "1") {
          //   if (this.jumpObj.data.data.supplierState === "0") {
          //     this.$router.push({
          //       path: "/eqReady"
          //     });
          //     sessionStorage.setItem(
          //       "localEq",
          //       JSON.stringify({
          //         check_page: "2",
          //         companyName: this.jumpObj.data.data.companyName,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   } else if (this.jumpObj.data.data.supplierState === "2") {
          //     this.$router.push({
          //       path: "/eqReady"
          //     });
          //     sessionStorage.setItem(
          //       "localEq",
          //       JSON.stringify({
          //         check_page: "4",
          //         companyName: this.jumpObj.data.data.companyName,
          //         success: true,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   } else if (this.jumpObj.data.data.supplierState === "4") {
          //     this.$router.push({
          //       path: "/eqReady"
          //     });
          //     sessionStorage.setItem(
          //       "localEq",
          //       JSON.stringify({
          //         check_page: "4",
          //         companyName: this.jumpObj.data.data.companyName,
          //         success: false,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   }

          //   //电子商城这里加
          // }
          // //分包
          // if (this.jumpObj.data.data.regSource === "2") {
          //   if (this.jumpObj.data.data.supplierState === "0") {
          //     this.$router.push({
          //       path: "/subReady"
          //     });
          //     // this.$eventBus.$emit("localSub", {
          //     //   check_page: "2",
          //     //   companyName: this.jumpObj.data.companyName,
          //     //   supplierCode: this.jumpObj.data.supplierCode
          //     // });
          //     sessionStorage.setItem(
          //       "local",
          //       JSON.stringify({
          //         check_page: "2",
          //         companyName: this.jumpObj.data.data.companyName,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   } else if (this.jumpObj.data.data.supplierState === "2") {
          //     this.$router.push({
          //       path: "/subReady"
          //     });
          //     // this.$eventBus.$emit("localSub", {
          //     //   check_page: "4",
          //     //   success: true,
          //     //   companyName: this.jumpObj.data.companyName,
          //     //   supplierCode: this.jumpObj.data.supplierCode
          //     // });
          //     sessionStorage.setItem(
          //       "local",
          //       JSON.stringify({
          //         check_page: "4",
          //         success: true,
          //         companyName: this.jumpObj.data.data.companyName,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   } else if (this.jumpObj.data.data.supplierState === "4") {
          //     this.$router.push({
          //       path: "/subReady"
          //     });
          //     // this.$eventBus.$emit("localSub", {
          //     //   check_page: "4",
          //     //   success: false,
          //     //   companyName: this.jumpObj.data.companyName,
          //     //   supplierCode: this.jumpObj.data.supplierCode
          //     // });
          //     sessionStorage.setItem(
          //       "local",
          //       JSON.stringify({
          //         check_page: "4",
          //         success: false,
          //         companyName: this.jumpObj.data.data.companyName,
          //         supplierCode: this.jumpObj.data.data.supplierCode
          //       })
          //     );
          //     if (this.jumpObj.data.data.point) {
          //       this.$message({
          //         message: this.jumpObj.data.data.point,
          //         type: "warning",
          //         offset: document.body.clientHeight / 2 - 21
          //       });
          //     }
          //     return false;
          //   }

          //   //电子商城这里加
          // }
        } else {
          if (this.jumpObj.data.data.supplierNames.length > 0) {
            this.isPhoneCompany = true;
            this.isNewCompany = false;
            this.isCompanyBeenReg = false;
            this.companyList = this.jumpObj.data.data.supplierNames;
            this.$eventBus.$emit("msg", this.form);
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21,
              });
            }
          } else {
            this.isNewCompany = true;
            this.isCompanyBeenReg = false;
            this.isPhoneCompany = false;
            this.$eventBus.$emit("msg", this.form);
            if (this.jumpObj.data.data.point) {
              this.$message({
                message: this.jumpObj.data.data.point,
                type: "warning",
                offset: document.body.clientHeight / 2 - 21,
              });
            }
          }
        }
        this.isCreate = false;
      }
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    nextViewFn() {
      this.$emit("nextPerfect", { name });
    },
    getCode() {
      this.$refs.countDown.style.backgroundColor = "rgba(242, 242, 242, 1)";
      this.$refs.countDown.style.color = "rgba(153, 153, 153, 1)";
      this.$refs.countDown.style.cursor = "no-drop";
      const TIME_COUNT = 59;
      this.second = TIME_COUNT;
      this.show = false;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.second > 0 && this.second <= TIME_COUNT) {
          this.second--;
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
      getPlatform(`mobile=${this.form.mobile}`)
        .then((res) => {
          this.isCode = false;
          if (res.data.code === "0") {
            if (res.data.message.includes("成功")) {
              this.isCode = true;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.second = 59;
              this.$message({
                message: res.data.message,
                type: "error",
                offset: this.messageHeight,
              });
            }
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.second = 59;
            this.$message({
              message: res.data.message,
              type: "error",
              offset: this.messageHeight,
            });
          }
        })
        .catch((errMessage) => {
          this.show = true;
          clearInterval(this.timer);
          this.second = 59;
          // this.$message({
          //   message: errMessage,
          //   type: "error"
          // });
        });
    },
    isExist({ flag, name }) {
      if (flag) {
        this.isCompanyBeenReg = flag;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCreate = false;
      } else {
        this.$emit("nextPerfect", { name });
      }
    },
    approval({ flag, name }) {
      console.log(flag, name);
      if (flag) {
        this.isApprovaling = flag;
        this.isNewCompany = false;
        this.isPhoneCompany = false;
        this.isCreate = false;
      } else {
        this.$emit("nextPerfect", { name });
      }
    },
    // 点击
    goIsPhone() {
      // if (!this.form.name || !/^1[3456789]\d{9}$/.test(this.form.mobile)) {
      // } else {
      //   this.isPhone = true;
      // }

      this.$refs.form.validateField("name", (nameError) => {
        this.$refs.form.validateField("mobile", (mobileError) => {
          if (!mobileError && !nameError) {
            this.isPhone = true;
          } else {
            return false;
          }
        });
      });
    },
    // 点击
    goPage() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
        } else {
          this.$nextTick(() => {
            const ele =
              this.$el.querySelector(".is-error") ||
              this.$el.querySelector(".is-required");
            console.log(ele);
            console.log(ele.offsetTop);
            if (ele) {
              // 获取到所在Row的offsetTop值
              window.scrollTo(
                0,
                ele.offsetTop || ele.parentNode.parentNode.parentNode.offsetTop
              );
            }
          });
          return false;
        }
      });
      if (
        !this.form.name ||
        !/^1[3456789]\d{9}$/.test(this.form.mobile) ||
        !/^\d{6}$/.test(this.form.inputAuthCode)
      ) {
        // this.$message({
        //   showClose: true,
        //   message: "请输入正确信息",
        //   type: "warning"
        // });
      } else {
        // start 需要验证手机验证码时打开
        // this.isNewCompany = true;
        // this.isCompanyBeenReg = false;
        // this.isPhoneCompany = false;
        // this.$eventBus.$emit("msg", this.form);
        // this.isCreate = false;
        // return false;
        // end

        //验证码接口好了以后打开start
        // if (!this.isCode) {
        //   this.$message({
        //     message: "请先获取验证码",
        //     type: "error"
        //   });
        //   return false;
        // }
        //验证码接口好了以后打开end

        //1113
        getCheckContact({
          name: this.form.name,
          inputAuthCode: this.form.inputAuthCode,
          mobile: this.form.mobile,
          loadingMessage: "验证中,请稍等...",
          isShowLoading: true,
        }).then((res) => {
          if (res.data.code === "0") {
            sessionStorage.setItem(
              "querySupplierCode",
              JSON.stringify({
                supplierCode: res.data.data.supplierCode,
              })
            );
            if (res.data.data.supplierState) {
              this.jumpObj = {};
              this.jumpObj = res;
              // if (this.agreeBtn === false) {
              //   return false;
              // } else {
              //   this.getCheckContact();
              // }
              //物资
              if (res.data.data.supplierState === "0") {
                this.regSourceShow = true;
                this.dialogContent =
                  "您的供应商合作申请还未完成，请继续完善信息后进行提交";
              } else if (res.data.data.supplierState === "2") {
                this.regSourceShow = true;
                this.dialogContent =
                  "您的供应商合作申请正在审批中，点击确定查看";
              } else if (res.data.data.supplierState === "4") {
                this.regSourceGo();
              }
            } else {
              if (res.data.data.supplierNames.length > 0) {
                this.isPhoneCompany = true;
                this.isNewCompany = false;
                this.isCompanyBeenReg = false;
                this.companyList = res.data.data.supplierNames;

                this.$eventBus.$emit("msg", this.form);
                if (res.data.data.point) {
                  this.$message({
                    message: res.data.data.point,
                    type: "warning",
                    offset: document.body.clientHeight / 2 - 21,
                  });
                }
              } else {
                this.isNewCompany = true;
                this.isCompanyBeenReg = false;
                this.isPhoneCompany = false;
                this.$eventBus.$emit("msg", this.form);
                if (res.data.data.point) {
                  this.$message({
                    message: res.data.data.point,
                    type: "warning",
                    offset: document.body.clientHeight / 2 - 21,
                  });
                }
              }
              this.isCreate = false;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
div {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* content */
.sign-content {
  width: 1180px;
  height: 450px;
  background: #FFFFFF;
  margin: 20px auto;
  overflow: hidden;
  .sign-content-h2 {
    height: 17px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #4A4A4A;
    letter-spacing: 0;
    line-height: 17px;
    margin-left: 70px;
    margin-top: 20px;
    font-weight: 600;
  }
  .sign-content-content {
    width: 1000px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #4A4A4A;
    text-align: left;
    font-weight: 400;
    margin-top: 20px;
    margin-left: 90px;
    line-height: 20px;
    p {
      padding-bottom: 20px;
    }
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}

/deep/.el-button.el-button--primary-font-mini {
  background-color: #ff142f;
  border-color: #ff142f;
}
/deep/.el-button.el-button--default-mini:hover {
  color: #ff142f;
}
</style>
<style scoped>
/deep/.el-input__inner {
  height: 40px;
  padding-left: 10px;
  line-height: 40px;
}
/deep/.el-input-group__prepend {
  background: rgba(255, 255, 255, 1);
  margin-bottom: 10px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
/deep/.el-icon-caret-bottom {
  line-height: 3;
}
/deep/.el-input-group {
  position: relative;
}
/deep/.inputBe {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: transparent;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 1px;
  top: 1px;
}
/deep/.inputBe2 {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: #fff;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 0px;
}
/deep/.inputBe2 .el-input__inner:hover {
  border: 1px solid #dcdfe6;
}
/deep/.inputPad .el-input__inner {
  padding-left: 82px;
}
/deep/.el-select {
  border: 1px solid rgba(204, 204, 204, 1) !important;
}
</style>
